
















































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils/index";

@Component({
  name: "system",
})
export default class UserManagement extends Vue {
  @Provide() private routeData: any = []; // 路由列表
  @Provide() private inputRoute: any = ""; // 搜索输入
  @Provide() private issearchRouteDone: boolean = false;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagnition: any = pagnition;
  @Provide() private pagerCount: number = 0;
  @Provide() private dialogEditVisible: boolean = false; // 编辑弹窗显示
  @Provide() private dialogAddVisible: boolean = false;  // 新增弹窗显示
  @Provide() private formEdit: any = {name:"", route:"", resourceId:""};  // 编辑form
  @Provide() private rules: any = {
    name: [{ required: true, message: "请输入路由名称", trigger: "blur" }],
    route: [{ required: true, message: "请输入路由值", trigger: "blur" }]
  };
  @Provide() private operateType: number = 1; // 1-添加操作， 2-编辑操作
  private created() {
    this.searchRouteAction()
  }
  // 添加路由
  private async addRoute () {
    let otp = {
      name: this.formEdit.name,
      route: this.formEdit.route,
    }
    const { createRouter }: any = await import(
      "@/request/getrouterList"
    );
    let res = await createRouter(otp, this);
    if (res) {
      this.dialogEditVisible = false;
      if(res.code === 0){
        this.$message({
          type: 'success',
          message: '添加成功!'
        });
        this.searchRouteRequest();
      }
    }
  }
  // 编辑路由
  private async editRoute () {
    let otp = {
      name: this.formEdit.name,
      route: this.formEdit.route,
      resourceId: this.formEdit.resourceId,
    }
    const { updateRouter }: any = await import(
      "@/request/getrouterList"
    );
    let res = await updateRouter(otp, this);
    if (res) {
      this.dialogEditVisible = false;
      if(res.code === 0){
        this.$message({
          type: 'success',
          message: '更新成功!'
        });
        this.searchRouteRequest();
      }
    }
  }
  // 删除路由
  private async deleteRoute(resourceId:any){
    let otp = {
      resourceId: resourceId,
    }
    const { deleteRouter }: any = await import(
      "@/request/getrouterList"
    );
    let res = await deleteRouter(otp, this);
    if (res) {
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
      this.searchRouteRequest();
    }
  };
  // 查询
  private async searchRouteRequest() {
    let otp = {
      name: this.inputRoute,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    }
    const { listRouter }: any = await import(
      "@/request/getrouterList"
    );
    let res = await listRouter(otp, this);
    this.issearchRouteDone = res ? res.loading : false;
    if (res) {
      this.routeData = this.searchRouteRequestFunc(res.resourcelistList);
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  // 
  private searchRouteRequestFunc (data:any){
    data.forEach((item:any)=>{
      item.operatortime = item.operatortime > 0 ? timeFormat(item.operatortime) : "";
    })
    return data;
  }
  // 删除路由确认弹窗
  private deleteRoutePop(resourceId:any, name:string){
    let tips = this.$tc("tipsLgy.ConfirmDelete") + name + "?";
    this.$confirm(tips, "提示", {
      confirmButtonText: this.$tc("ticket.Sure"),
      cancelButtonText: this.$tc("authority.cancel"),
      type: "warning"
    }).then(() => {
      this.deleteRoute(resourceId);
    });
  };
  // 编辑/添加路由弹窗
  editRoutePop (name:string, route:string, resourceId: string, type: number) {
    this.formEdit.name = name;
    this.formEdit.route = route;
    this.formEdit.resourceId = resourceId;
    this.operateType = type;
    this.dialogEditVisible = true;
  };
  // 编辑/添加路由确认提交
  submitRoute () {
    const ref: any = this.$refs["formEdit"];
    ref.validate((valid: boolean) => {
      if (valid) {
        this.operateType === 1 ? this.addRoute() : this.editRoute();
      }
    })
  };
  // 搜索操作
  private searchRouteAction() {
    this.pageIndex = 1;
    this.searchRouteRequest();
  };
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    this.searchRouteRequest();
  };
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      this.searchRouteRequest();
    }
  };
  //点击下一页
  private handleNextChange(val: any) {
      this.searchRouteRequest();
  };
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    this.searchRouteRequest();
  };
}
